import { presenceCost, validate, validateEmailRule } from '@/core/tools'
const constraints = {
    email: { presence: presenceCost, email: validateEmailRule },
    password: { presence: presenceCost, length: { minimum: 6 } },
}

export const validateSignIn = (data: any) => {
    return validate<any>(data, constraints)
}
